export class PathConstant {
  public static readonly ROOT = '/';

  public static readonly FORGOT_PASSWORD = '/forgot-password';
  public static readonly HOME = '/home';
  public static readonly LOGIN = '/login';
  public static readonly SETTING = '/setting';
  // public static readonly SETTLEMENT_INFO = '/settlement-info';
}
